import script from "./ConfidenceChip.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfidenceChip.vue?vue&type=script&setup=true&lang=js"

import "./ConfidenceChip.vue?vue&type=style&index=0&id=77a2c426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a2c426"]])

export default __exports__